import { NavigateFunction } from 'react-router';
import { clearAppState } from './clearAppState';

interface LogoutOptions {
  navigate: NavigateFunction;
  setUser: (user: any) => void;
  resetConversations: () => void;
  resetArchive: () => void;
  notifications: any[];
  removeNotification: (index: number) => void;
  reactConfig: string | number;
}

/**
 * Performs a complete logout of the user including:
 * - API logout request
 * - Clearing all app state
 * - Resetting contexts
 * - Clearing notifications
 * - Navigation to home
 */
export const performLogout = async (options: LogoutOptions): Promise<void> => {
  const {
    navigate,
    setUser,
    resetConversations,
    resetArchive,
    notifications,
    removeNotification,
    reactConfig: reactConfigValue
  } = options;

  try {
    await fetch('/user/credentials/logout', { method: 'POST' });
  } catch (e) {
    // ignore errors
  }
  
  // Clear all app state
  clearAppState();

  // Broadcast a logout event so interested contexts can clear their in-memory state
  try {
    // Use a CustomEvent to allow future payloads if needed
    window.dispatchEvent(new CustomEvent('app:logout'));
  } catch (_) {
    // no-op in non-browser environments
  }
  
  // Reset context states
  resetConversations();
  resetArchive();
  
  // Clear notifications
  notifications.forEach((_, index) => removeNotification(index));
  
  // Clear user from app context
  setUser(undefined);
  
  // Navigate to home
  navigate('/');
  
  if (+reactConfigValue === 1) {
    navigate(0);
  }
};